<template>
  <v-select
    :id="id"
    :value="value"
    :options="computedOptions"
    :loading="loading"
    :reduce="reduce"
    :label="label"
    :select-on-tab="selectOnTab"
    :clearable="clearable"
    :placeholder="placeholder"
    class="w-100 d-print-none"
    v-bind="$attrs"
    v-on="$listeners"
    @input="$emit('input', $event)"
    @search="$emit('search', $event)">

    <template #option="option">
      <span :class="{'text-danger': ['__EMPTY__', '__HAS_VALUE__'].includes(option.value)}">
        {{ option.label }}
      </span>
    </template>

    <template #selected-option="option">
      <span :class="{'text-danger': ['__EMPTY__', '__HAS_VALUE__'].includes(option.value)}">
        {{ option.label }}
      </span>
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select'

const EXTRA_VALUES = {
  EMPTY: '__EMPTY__',
  HAS_VALUE: '__HAS_VALUE__',
}

export default {
  name: 'TableFilter',
  components: { vSelect },
  inheritAttrs: false, // we manually forward $attrs to v-select

  props: {
    /* v-model support */
    value: { type: [String, Number, Object, Array, Boolean, null], default: null },

    /* common v-select props you’re using */
    options: { type: Array, default: () => [] },
    label: { type: String, default: 'label' },
    reduce: { type: Function, default: (opt) => (opt && typeof opt === 'object' ? opt.value : opt) },
    loading: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true },
    selectOnTab: { type: Boolean, default: true },
    placeholder: { type: String, default: '' },
    id: { type: String, default: 'ensemble-input' },
  },

  computed: {
    computedOptions() {
      // Build the injected options using whatever label key the parent wants
      const injected = this.buildInjected(this.label)

      // If your original options already include one/both values, avoid duplicating
      const existingValues = new Set(
        (this.options || [])
          .map(o => ((o && typeof o === 'object' && 'value' in o) ? o.value : null))
          .filter(v => v !== null)
      )

      const finalExtras = injected.filter(o => !existingValues.has(o.value))

      // Prepend extras so they’re always available and easy to find
      return [...finalExtras, ...this.options]
    },
  },

  methods: {
    buildInjected(labelKey) {
      // Ensure we also set the generic 'label' key so fallback rendering works
      const mk = (value, text) => ({
        value,
        [labelKey]: text,
        label: text,
      })

      return [
        mk(EXTRA_VALUES.EMPTY, 'Is Empty'),
        mk(EXTRA_VALUES.HAS_VALUE, 'Has Value'),
      ]
    },
  },
}
</script>

<style scoped>
/* optional */
</style>
